<div class="dropdown-menu-container">
  <span
    class="text-indicator"
    [matTooltip]="textIndicatorTooltip ?? ''"
    [matTooltipDisabled]="!textIndicatorTooltip"
  >{{ textIndicator ? textIndicator : '' }}</span>
  <button
    mat-icon-button
    class="dropdownTrigger"
    [matMenuTriggerFor]="menu"
    (click)="$event.stopPropagation()"
    (keydown.enter)="$event.stopPropagation()"
    (keydown.space)="$event.stopPropagation()"
    [attr.aria-label]="ariaLabel"
    [style.width.px]="dropdownOpenIconWidth+16"
    [style.height.px]="dropdownOpenIconHeight+16"
  >
    @if (imageIconUrl) {
      <img
        class="dropdownIcon"
        [src]="imageIconUrl"
        [style.width.px]="dropdownOpenIconWidth"
        [style.height.px]="dropdownOpenIconHeight"
        alt=""/>
    } @else {
      <mat-icon class="material-symbols-outlined">{{ materialIconName }}</mat-icon>
    }
  </button>
</div>

<mat-menu #menu="matMenu" [class]="menuClass">
  <ng-content></ng-content>
</mat-menu>
